/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_at_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave empty to use today`)
};

const es_age_at_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejar vacío para usar hoy`)
};

const de_age_at_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer lassen, um heute zu verwenden`)
};

const nl_age_at_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laat leeg om vandaag te gebruiken`)
};

const fr_age_at_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laisser vide pour utiliser aujourd'hui`)
};

const it_age_at_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lascia vuoto per usare oggi`)
};

const pt_br2_age_at_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixe em branco para usar hoje`)
};

const pt_age_at_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixe vazio para usar hoje`)
};

const ja_age_at_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空のままにすると今日を使用します`)
};

const zh_age_at_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`留空则使用今天`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_at_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_at_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_at_hint", locale)
	if (locale === "en") return en_age_at_hint(inputs)
	if (locale === "es") return es_age_at_hint(inputs)
	if (locale === "de") return de_age_at_hint(inputs)
	if (locale === "nl") return nl_age_at_hint(inputs)
	if (locale === "fr") return fr_age_at_hint(inputs)
	if (locale === "it") return it_age_at_hint(inputs)
	if (locale === "pt-BR") return pt_br2_age_at_hint(inputs)
	if (locale === "pt") return pt_age_at_hint(inputs)
	if (locale === "ja") return ja_age_at_hint(inputs)
	return zh_age_at_hint(inputs)
};